// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".chat-button[data-v-447a5616]{display:flex;align-items:center;justify-content:center;width:55px;height:55px;border-radius:55px;background-color:#ff6352;color:#fff;box-shadow:0 5px 14px 0 rgba(0,0,0,.3)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
